import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { Router } from '@angular/router';

export class ValidationService {
  static emailValidator(control) {
    // tslint:disable-next-line: max-line-length
    if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
      return null;
    } else {
      return { invalidEmailAddress: true };
    }
  }
  static passwordValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{4,100}$/)) {
      return null;
    } else {
      return { invalidPassword: true };
    }
  }
}

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})

export class SignupComponent implements OnInit {

  registerForm: FormGroup;
  submitted = false;
  loginvalid: boolean;
  ErrorShow: boolean;
  ErrorMsg: any;
  siteKey: string = '6LeN2uIdAAAAAJG9z-hcTqBAY_mXgPwfW1bFCfD8';

  constructor(
    private meta: Meta,
    private title: Title,
    private router: Router,
    public authService: AuthService,
    private formBuilder: FormBuilder
  ) {
    this.ErrorShow = true;
    let userid = (Math.random() + 1).toString(36).substring(2);
    this.registerForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, ValidationService.emailValidator]],
      phone: ['', Validators.required],
      password: ['', [Validators.required, ValidationService.passwordValidator]],
      confirmpassword: ['', [Validators.required, ValidationService.passwordValidator]],
      recaptcha: ['', Validators.required],
      acceptTerms: [false, Validators.requiredTrue]
    }, {validator: this.checkPasswords });
    this.authService.SignupError.subscribe(error => {
      this.ErrorShow = false;
      this.loginvalid = false;
      this.ErrorMsg = error;
      setTimeout(() => {
        this.ErrorShow = true;
      }, 10000);
    });
  }
  get f() {
    return this.registerForm.controls;
  }
  signup() {
    this.loginvalid = true;
    this.submitted = true;
    if (this.registerForm.invalid) {
      this.loginvalid = false;
      return;
    }
    // this.authService.signup(this.registerForm.value);
    this.authService.pySignup(this.registerForm.value).subscribe((res: any) => {
      this.router.navigate(['profile']);
    }, err => {
      this.loginvalid = false;
      var errObjKeys = Object.keys(err.error.data);
      if (errObjKeys.length > 0) {
        console.log(err.error.data[errObjKeys[0]].join());
        this.ErrorShow = false;
        this.ErrorMsg = err.error.data[errObjKeys[0]].join();
      }
      // if (err.error instanceof Object) {
      //   console.log(err.error.join());
      // } else {
      //   if (err.error != undefined) {
      //     console.log(err.error);
      //   }
      // }
    })
  }
  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    if (e.which === 46) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }
  ngOnInit() {
    this.title.setTitle('Registration - Massage Robotics');
    this.meta.updateTag({ name: 'Description', content: 'Massage Robotics' });
    this.meta.updateTag({ name: 'Keywords', content: 'Massage Robotics' });
  }

  checkPasswords(group: FormGroup) {
    const pass = group.get('password').value;
    const confirmPass = group.get('confirmpassword').value;
    return pass === confirmPass ? null : { notSame: true };
  }

}
